<template>
    <svg width="13" height="27" viewBox="0 0 13 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L11 13.5L0.999999 26" stroke="#00458D" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGHelpArrowRight',
};
</script>

<style scoped lang="scss">

</style>
